import React from "react";
import { useTranslation } from "react-i18next";

export default function NotificationTextInfo() {
  const { t } = useTranslation();
  return (
    <p className="tw-text-xs tw-text-white/40 tw-px-2 tw-pb-3 tw-m-0">
      {t("Find all the users film industry professionals who favourite and follow your film, and those who requests access to your protected EPKs.")}
    </p>
  );
}
